import { useMemo } from 'react';
import { normaliseSite, getFeatureColor } from '../utils/siteStatus';

export function useVisibleSites(sites, filters, hideInactive) {
	const colouredSites = useMemo(function() {
		return sites.map(function(site) {
			return normaliseSite(site, filters.startDate, filters.endDate, filters.activityStatus);
		});
	}, [sites, filters.startDate, filters.endDate, filters.activityStatus]);

	const visibleSites = useMemo(function() {
		return colouredSites.filter(function(s) {
			// hideInactive: remove sites with no activity
			if (hideInactive && s._status === 'none' && !s._overdue) return false;
			return true;
		});
	}, [colouredSites, hideInactive]);

	const featureStats = useMemo(function() {
		var result = {};
		colouredSites.forEach(function(s) {
			if (s._status !== 'none' && s._feature) {
				if (!result[s._feature]) {
					result[s._feature] = { color: getFeatureColor(s._feature), count: 0 };
				}
				result[s._feature].count++;
			}
		});
		return result;
	}, [colouredSites]);

	const stats = useMemo(function() {
		var c = { inprogress: 0, planned: 0, none: 0, overdue: 0 };
		visibleSites.forEach(function(s) {
			c[s._status] = (c[s._status] || 0) + 1;
			if (s._overdue) c.overdue++;
		});
		return c;
	}, [visibleSites]);

	return { colouredSites, visibleSites, featureStats, stats };
}